enum HttpStatusCode {
  OK = 200,
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  InternalServer = 500,
  GatewayTimeout = 504,
}

export default HttpStatusCode;
